import React from 'react';

const HorseIcon = (props) => {
  return (
    <img
      alt="Stajnia"
      src="/static/images/icons/tourist_attractions/horse.svg"
      {...props}
    />
  );
};

export default HorseIcon;
